import React from 'react';

import { useRouter } from 'next/router';

import { ServiceOSLoginWrapper } from './ServiceOSLogin.styles';

export const ServiceOSLogin = () => {
  const { locale } = useRouter();
  const isFrench = locale === 'fr-fr';

  return (
    <ServiceOSLoginWrapper
      className="accounts-menu-holder"
      data-menu-layout="avatar"
      data-menu-title-text={isFrench ? 'MON COMPTE' : ''}
      data-menu-heading-text={isFrench ? 'Vous avez déjà un compte ?' : ''}
      data-menu-cta-text={isFrench ? 'Se connecter' : 'Login'}
      data-menu-logout-text={isFrench ? 'Se déconnecter' : ''}
      data-menu-footer-text-part1={isFrench ? 'Pas de compte ?' : ''}
      data-menu-footer-text-part2={isFrench ? 'Commencez ici' : 'Sign up here'}
      data-menu-title-color="#000000"
      data-menu-primary-color="#FAC600"
      data-menu-primary-color-dark="#FAC600"
      data-menu-secondary-color="#000000"
      data-menu-button-text-color="#000000"
      data-menu-text-color="#000000"
      data-menu-background-color="#E0E0DF"
      style={{
        display: 'inline-block',
        fontFamily: 'Roboto, sans-serif',
      }}
    />
  );
};
